import { render, staticRenderFns } from "./ReachComp.vue?vue&type=template&id=242d5be4&scoped=true"
import script from "./ReachComp.vue?vue&type=script&lang=js"
export * from "./ReachComp.vue?vue&type=script&lang=js"
import style0 from "./ReachComp.vue?vue&type=style&index=0&id=242d5be4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242d5be4",
  null
  
)

export default component.exports